import type { ApiLoopSearchResponse } from '../../../search/api/responses/searchResponses';
import type { ApiPersonalizationQueryParams } from '../../../search/api/searchRequests';
import type { ApiLoopProduct } from './apiProductModels';

import getDirectPersonalizationSearchAxiosClient, {
    prepareRequestParams,
} from '../../../search/api/directPersonalizationAxiosClient';

export const getProductsByIds = async (
    ids: string[],
    storeId: string,
    options?: Pick<ApiPersonalizationQueryParams, 'customerGroups' | 'device'>,
) => {
    const client = getDirectPersonalizationSearchAxiosClient(false);

    const response = await client.post<ApiLoopSearchResponse<ApiLoopProduct>>(
        '/search/entities/by-id',
        ids,
        {
            params: prepareRequestParams({
                storeId,
                customerGroups: options?.customerGroups,
                device: options?.device,
                quickSearch: false,
            }),
        },
    );
    return response.data?.results?.items || [];
};

export const directProductApi = {
    getProductsByIds,
};
